import { createIcon } from '../createIcon';

export const MixerIconConfig = {
  name: 'MixerIcon',
  height: 512,
  width: 512,
  svgPath: 'M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const MixerIcon = createIcon(MixerIconConfig);

export default MixerIcon;